module.exports = __webpack_public_path__ + "img/arnold-moses-front-right-wesley-burnham-front-left-107th-battalion-cef.bb5d7178.jpg";